import React, { useEffect, useState } from "react";

const OrderList = ({data, setData}) => {
  const [orderData, setOrderData] = useState(data.orderData);

  const pushDummy = () => {
    for(let i = orderData.length; i <= 12; i++) {
      setOrderData([...orderData,
        {}
      ]);
    }
  } 
  useEffect(() => {
    pushDummy();
  }, [orderData])
  return (
    <div className="border text-xs border-black grid grid-cols-11 w-[100%]">
        {/* Header */}
        
        <StyledDiv text={"일자"} addStyle={"py-3"}/>
        <StyledDiv text={"품목명[규격]"} addStyle={"py-3 col-span-5"}/>
        <StyledDiv text={"수량"} addStyle={"py-3"}/>
        <StyledDiv text={"단위"} addStyle={"py-3"}/>
        <StyledDiv text={"단가"} addStyle={"py-3"}/>
        <StyledDiv text={"공급가액"} addStyle={"py-3"}/>
        <StyledDiv text={"부가세"} addStyle={"py-3"}/>

        {/* data */}
        {
          orderData.map((data, index) => {
            return <Order data={data} key={index} />
          })
        }
      </div>
  )
}


const StyledDiv = ({text, addStyle}) => {
  return (
    <div className={`min-h-4 px-1 border-r border-b border-black ${addStyle}`}>{text}</div>
  )
}

const Order = ({data}) => {

  const priceComma = (price) => {
    return price && price.toLocaleString('ko-KR', {maximumFractionDigits: 0})
  }

  return (
    <>
      <StyledDiv text={data.date}/>
      <StyledDiv text={data.productName} addStyle={"col-span-5 text-left"}/>
      <StyledDiv text={priceComma(data.count)} addStyle={"text-right"}/>
      <StyledDiv text={data.unit}/>
      <StyledDiv text={priceComma(data.unitPrice)} addStyle={"text-right"}/>
      <StyledDiv text={priceComma(data.supplyPrice)} addStyle={"text-right"}/>
      <StyledDiv text={priceComma(data.surtax)} addStyle={"text-right"}/>
    </>
  )
}


export default OrderList;

